export default __webpack_public_path__ + "static/media/xpensityV2-tablet-side.a15f45cc.webp";